import { createSlice, createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { nextId } from "../../utils";

const propertiesAdapter = createEntityAdapter();

const initialProperty = {id: 0, code: ""};

const emptyInitialState = propertiesAdapter.getInitialState({status: "idle"});
const initialState = propertiesAdapter.upsertOne(emptyInitialState, initialProperty);

const propertiesSlice = createSlice({
	name: "properties",
	initialState,
	reducers: {
		propertyAdded(state, action) {
			const id = nextId(state.ids);
			const property = {
				id,
				code: action.payload
			};
			propertiesAdapter.addOne(state, property);
		},
		editProperty: propertiesAdapter.updateOne,
		propertyDeleted(state, action) {
			propertiesAdapter.removeOne(state, action.payload);
		}
	},
	extraReducers: builder => {
		builder
			.addCase("calculators/loadCalculator/pending", (state) => {
				state.status = "loading";
			})
			.addCase("calculators/loadCalculator/fulfilled", (state, action) => {
				if(action.payload.type === "mortgage") {
					propertiesAdapter.setAll(state, JSON.parse(action.payload.json).calc.properties.entities)
					state.status = "idle";
				}
			})
	}
})

export const {
	editProperty,
	propertyAdded,
	propertyDeleted
} = propertiesSlice.actions;

export default propertiesSlice.reducer

export const { selectAll: selectProperties, selectById: selectPropertyById } = propertiesAdapter.getSelectors(state => state.mortgage.properties);

export const selectPropertyIds = createSelector(
	selectProperties,
	properties => properties.map(property => property.id)
);
